Ext.define('SA.data.Years', {
    singleton: true,

    years: {},

    forCountry(country) {
        return (this.years[country] || []).slice();
    },

    load(country) {
        var query = SA.data.Query.from({
            facets: ['year'],
            type: 'attributes',
            where: SA.data.AttributesQuery.getCountryAndStatusVisiblePredicateyWithTreeStatusOverride(country)
        });

        query.addSuccess(response => {
            var countryCode = country.getCode(),
                years = Object.keys(response.facets.year).map(Number);

            this.years[countryCode] = years;
        });

        return query.run();
    },

    loadAll() {
        var countries = SA.Institution.getCountries();

        return Promise.all(countries.map(country => this.load(country)));
    }
});